module.exports = __webpack_public_path__ + "img/conteudo-card-o-evangelista.6d05a16e.png";